import Component from "@glimmer/component";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { gt } from "discourse/truth-helpers";
import { i18n } from "discourse-i18n";

export default class CommunityFeedbackMediaStrip extends Component {
  @action
  scrollNext(event) {
    event.currentTarget.previousElementSibling?.scrollBy({
      left: 432,
      behavior: "smooth",
    });
  }

  <template>
    {{#if @media.length}}
      <div class="community-feedback-media">
        <div class="community-feedback-media__track">
          {{#each @media as |media|}}
            <a
              class="community-feedback-media__link"
              href={{@url}}
              aria-label={{@title}}
            >
              <img
                class="community-feedback-media__image community-feedback-card__image"
                src={{media.url}}
                alt=""
                loading="lazy"
              />
            </a>
          {{/each}}
        </div>
        {{#if (gt @media.length 3)}}
          <button
            type="button"
            class="community-feedback-media__next"
            aria-label={{i18n "community_feedback.next_media"}}
            {{on "click" this.scrollNext}}
          >
            <span aria-hidden="true"></span>
          </button>
        {{/if}}
      </div>
    {{/if}}
  </template>
}
